/* TextColorHighlightMenu.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./TextColorHighlightMenu.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { toggleHighlightPalette, ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { textColorMessages as messages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette';
import { TextColorIcon, ToolbarColorSwatch, ToolbarDropdownMenu, ToolbarDropdownMenuProvider, ToolbarTooltip, getContrastingBackgroundColor, useToolbarUI } from '@atlaskit/editor-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
var styles = {
  menu: "_1rjcv77o _18zru2gc"
};
var getIconColor = function getIconColor(textColor, defaultColor, highlightColor) {
  if (highlightColor || !textColor || textColor === defaultColor && defaultColor) {
    return "var(--ds-text, #172B4D)";
  }
  return hexToEditorTextPaletteColor(textColor) || "var(--ds-text, #172B4D)";
};
export var TextColorHighlightMenu = function TextColorHighlightMenu(_ref) {
  var _api$textColor2;
  var children = _ref.children,
    api = _ref.api;
  var isHighlightPluginExisted = !!(api !== null && api !== void 0 && api.highlight);
  var isTextColorDisabled = useSharedPluginStateSelector(api, 'textColor.disabled');
  var _useToolbarUI = useToolbarUI(),
    isToolbarDisabled = _useToolbarUI.isDisabled;
  var isDisabled = expValEquals('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? Boolean(isToolbarDisabled || isTextColorDisabled) : isTextColorDisabled;
  var highlightColor = useSharedPluginStateSelector(api, 'highlight.activeColor');
  var textColor = useSharedPluginStateSelector(api, 'textColor.color');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var defaultColor = useSharedPluginStateSelector(api, 'textColor.defaultColor');
  var isPaletteOpen = useSharedPluginStateSelector(api, 'textColor.isPaletteOpen');
  var setIsPaletteOpen = useCallback(function (isOpen) {
    var _api$textColor;
    if (api !== null && api !== void 0 && (_api$textColor = api.textColor) !== null && _api$textColor !== void 0 && (_api$textColor = _api$textColor.commands) !== null && _api$textColor !== void 0 && _api$textColor.setPalette) {
      api.core.actions.execute(function (_ref2) {
        var tr = _ref2.tr;
        api.textColor.commands.setPalette(isOpen)({
          tr: tr
        });
        return tr;
      });
    }
  }, [api === null || api === void 0 || (_api$textColor2 = api.textColor) === null || _api$textColor2 === void 0 ? void 0 : _api$textColor2.commands, api === null || api === void 0 ? void 0 : api.core.actions]);
  useEffect(function () {
    return function () {
      if (expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && fg('platform_editor_toolbar_aifc_patch_7')) {
        if (isPaletteOpen) {
          setIsPaletteOpen(false);
        }
      }
    };
  }, [setIsPaletteOpen, isPaletteOpen]);
  var iconColor = getIconColor(textColor, defaultColor, highlightColor);
  var highlightColorIcon = highlightColor ? highlightColor : getContrastingBackgroundColor(iconColor);
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: /*#__PURE__*/React.createElement(ToolTipContent, {
      description: formatMessage(isHighlightPluginExisted ? messages.textColorHighlightTooltip : messages.textColorTooltip),
      keymap: toggleHighlightPalette
    })
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenuProvider, {
    isOpen: expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? isPaletteOpen : undefined,
    setIsOpen: expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? setIsPaletteOpen : undefined
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    iconBefore: /*#__PURE__*/React.createElement(ToolbarColorSwatch, {
      highlightColor: highlightColorIcon
    }, /*#__PURE__*/React.createElement(TextColorIcon, {
      label: formatMessage(messages.textColorTooltip),
      iconColor: iconColor,
      shouldRecommendSmallIcon: true,
      size: 'small',
      isDisabled: isDisabled,
      spacing: 'compact'
    })),
    isDisabled: isDisabled,
    testId: "text-color-highlight-menu",
    hasSectionMargin: false
  }, expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? children : /*#__PURE__*/React.createElement(Box, {
    xcss: styles.menu
  }, children))));
};